import { Dimensions } from 'react-native';

/**
 * Layout constants for consistent sizing across the app
 */

// Screen dimensions
const SCREEN_HEIGHT = Dimensions.get('window').height;
const SCREEN_WIDTH = Dimensions.get('window').width;

// Home screen header dimensions
export const HERO_HEIGHT_MAX = SCREEN_HEIGHT * 0.35; // Maximum header height (35% of screen)
export const HERO_HEIGHT_MIN = 80; // Minimum collapsed header height
export const HEADER_SCROLL_DISTANCE = HERO_HEIGHT_MAX - HERO_HEIGHT_MIN; // Distance to scroll before fully collapsed

// Export screen dimensions for convenience
export { SCREEN_HEIGHT, SCREEN_WIDTH };
